import React from "react";
import { Row, Col, DatePicker, Select, Button, Space } from "antd";
import { SearchOutlined, ClearOutlined, DownloadOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

const eventTypeOptions = [
  { label: "Enviados", value: "Send" },
  { label: "Entregues", value: "Delivery" },
  { label: "Abertos", value: "Open" },
  { label: "Cliques", value: "Click" },
  { label: "Bounces", value: "Bounce" },
  { label: "Reclamacoes", value: "Complaint" },
];

const FiltersBar = ({
  filters,
  subjects,
  onFiltersChange,
  onSearch,
  onClear,
  onExport,
  loading,
}) => {
  const handleDateChange = (dates) => {
    if (dates && dates.length === 2) {
      onFiltersChange({
        startDate: dates[0].format("YYYY-MM-DD"),
        endDate: dates[1].format("YYYY-MM-DD"),
      });
    } else {
      onFiltersChange({
        startDate: null,
        endDate: null,
      });
    }
  };

  const handleEventTypeChange = (value) => {
    onFiltersChange({ eventType: value ? value.join(",") : "" });
  };

  const handleSubjectChange = (value) => {
    onFiltersChange({ subject: value || "" });
  };

  return (
    <div
      style={{
        background: "#fafafa",
        padding: "16px",
        borderRadius: "8px",
        marginBottom: "16px",
      }}
    >
      <Row gutter={[16, 16]} align="middle">
        <Col xs={24} sm={24} md={8} lg={6}>
          <RangePicker
            style={{ width: "100%" }}
            placeholder={["Data Inicio", "Data Fim"]}
            value={
              filters.startDate && filters.endDate
                ? [dayjs(filters.startDate), dayjs(filters.endDate)]
                : null
            }
            onChange={handleDateChange}
            allowClear
          />
        </Col>

        <Col xs={24} sm={12} md={8} lg={5}>
          <Select
            mode="multiple"
            style={{ width: "100%" }}
            placeholder="Tipo de Evento"
            options={eventTypeOptions}
            value={filters.eventType ? filters.eventType.split(",") : []}
            onChange={handleEventTypeChange}
            allowClear
            maxTagCount={2}
          />
        </Col>

        <Col xs={24} sm={12} md={8} lg={5}>
          <Select
            style={{ width: "100%" }}
            placeholder="Assunto"
            showSearch
            optionFilterProp="children"
            value={filters.subject || undefined}
            onChange={handleSubjectChange}
            allowClear
          >
            {subjects.map((subject) => (
              <Select.Option key={subject} value={subject}>
                {subject.length > 40 ? `${subject.substring(0, 40)}...` : subject}
              </Select.Option>
            ))}
          </Select>
        </Col>

        <Col xs={24} sm={24} md={24} lg={8}>
          <Space wrap>
            <Button
              type="primary"
              icon={<SearchOutlined />}
              onClick={onSearch}
              loading={loading}
            >
              Buscar
            </Button>
            <Button icon={<ClearOutlined />} onClick={onClear}>
              Limpar
            </Button>
            <Button
              icon={<DownloadOutlined />}
              onClick={onExport}
              loading={loading}
            >
              Exportar CSV
            </Button>
          </Space>
        </Col>
      </Row>
    </div>
  );
};

export default FiltersBar;
